export const getSanityContentUpdateMessage = ({
  type,
  action,
  prodLink,
  editLink,
  name,
  transactionTime,
}: {
  type: string;
  action: string;
  prodLink: string;
  editLink: string;
  name: string;
  transactionTime: string;
}) => ({
  unfurl_links: false,
  unfurl_media: false,
  blocks: [
    {
      type: 'section',
      text: {
        type: 'mrkdwn',
        text: `${action.slice(0, 1).toUpperCase() + action.slice(1)}d ${type === 'post' ? 'Blog Post' : 'Marketing Page'}: *<${editLink}|${name}>*`,
      },
    },
    {
      type: 'section',
      text: {
        type: 'mrkdwn',
        text: `*Action:* ${action}\n*When:* ${new Date(
          transactionTime
        ).toLocaleString()}`,
      },
    },
    {
      type: 'section',
      text: {
        type: 'mrkdwn',
        text: `*<${editLink}|Edit in Sanity>*\n*<${prodLink}|View live in production>*`,
      },
    },
  ],
});
